const GridonetServices = (instance) => {
  const login = (token, userId) =>
    instance.post('grido-net/login', { token, userId, b2b: true });

  return {
    login,
  };
};
export default GridonetServices;
